<template>
	<el-menu @select="onMenuSelect" unique-opened :default-active="activeId" class="party-menu">
		<menu-item v-for="(item,index) in list" :key="index" :item="item" />
	</el-menu>
</template>

<script>
	import MenuItem from "@/components/common/menuitem.vue";
	import { mapState } from 'vuex'
	export default {
		data() {
			return {
				activeId: this.$route.query.catalogId
			}
		},
		components: {
			MenuItem
		},
		computed: {
			...mapState('cms', {
				list: state => {
					function toNode(v) {
						return {
							id: v.id,
							name: v.name,
							path: v.id,
							children: v.children ? v.children.map(i => toNode(i)) : null
						}
					}
					return state.catalogNodeList.map(n => toNode(n))
				},
				currentCatalog: state => state.currentCatalog
			}),
		},
		watch: {
			currentCatalog(v) {
				if (v) {
					this.activeId = v.id
					sessionStorage.setItem('cms-catalogId', v.id)
				}
			}
		},

		methods: {
			onMenuSelect(id) {
				this.$store.commit('cms/setCurrentId', id)
				this.$router.push(`/party-build/index?catalogId=${id}`)
			},


		},
		mounted() {
			this.$store.dispatch('cms/getCatalogNodeList', { permission: false }).then(res => {
				const sessionCatalogId = sessionStorage.getItem('cms-catalogId')
				if (this.activeId) {
					this.$store.commit('cms/setCurrentId', parseInt(this.activeId))
					sessionStorage.setItem('cms-catalogId', this.activeId)
				} else if (sessionCatalogId) {
					this.$store.commit('cms/setCurrentId', sessionCatalogId)
				} else if (this.list.length > 0) {
					this.$store.commit('cms/setCurrentId', this.list[0].id)
				}
			})
		}
	}
</script>

<style lang="scss" scoped>
	.party-menu {
		background-color: rgba($color: #fff, $alpha: 0.6);
		.el-menu-item.is-active {
			// background-color: #f9f7e8;
			background-color: #e54b4b;
			color: yellow;
		}
		.el-menu-item {
			// background-color: rgba($color: #fff, $alpha: 0.6);
			line-height: 50px;
			height: 50px;
		}
		& /deep/.el-menu {
			background-color: rgba($color: #fff, $alpha: 0.6);
		}
		.el-submenu {
			// background-color: rgba($color: #fff, $alpha: 0.6);
			& /deep/.el-menu-item.is-active {
				background-color: #e54b4b;
				color: yellow;
				// border-right: 4px solid #e54b4b;
			}
			& /deep/.el-menu-item {
				// background-color: rgba($color: #fff, $alpha: 0.6);
				line-height: 50px;
				height: 50px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/party-build/menu.vue